export default __webpack_public_path__ + "static/media/logo-light.3f31c424.svg";